import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, CheckCircle2, Shield, Target, Brain, Database, X } from 'lucide-react';
export function HowContextWorks() {
  const scrollToTop = () => {
    window.scrollTo(0, 0);
  };
  return <section className="w-full py-24 px-6 md:px-12 lg:px-24 bg-gray-50" data-id="element-690">
      <div className="max-w-7xl mx-auto" data-id="element-691">
        <div className="text-center mb-16" data-id="element-692">
          <h2 className="text-4xl md:text-5xl font-bold font-['Syne'] mb-6 text-black" data-id="element-693">
            From Things Experts Know, to Rules AI Follows
          </h2>
        </div>

        {/* What Synthia Captures */}
        <div className="mb-16" data-id="element-694">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-695">
            <CaptureCard title="Compliance Rules" example='"Never mention pricing in patient communications"' result="becomes a structural attribute, not a thing humans remember to add." outcome="Zero regulatory violations in 18 months" data-id="element-696" />
            <CaptureCard title="Quality Standards" example='"Client-ready analysis includes three comparable transactions"' result="becomes automatic, not aspirational." outcome="85% reduction in internal review cycles" data-id="element-697" />
            <CaptureCard title="Decision Frameworks" example='"Our CFO kills deals when EBITDA multiples exceed 12x"' result="becomes embedded logic, not tribal knowledge." outcome="100% consistency across 40+ analysts" data-id="element-698" />
            <CaptureCard title="Expert Judgment" example='"Escalate adverse events within 4 hours if severity meets these criteria"' result="becomes machine-executable, not human-dependent." outcome="Zero missed escalations, 60% faster response time" data-id="element-699" />
          </div>
        </div>
      </div>
    </section>;
}
function CaptureCard({
  title,
  example,
  result,
  outcome
}: {
  title: string;
  example: string;
  result: string;
  outcome: string;
}) {
  return <div className="bg-white p-8 rounded-xl border border-gray-200 shadow-sm hover:shadow-md transition-shadow" data-id="element-700">
      <h4 className="text-xl font-bold font-['Syne'] text-black mb-4" data-id="element-701">
        {title}
      </h4>
      <div className="bg-gray-50 p-4 rounded-lg mb-4 italic text-gray-700 border-l-4 border-[#0066FF]" data-id="element-702">
        {example}
      </div>
      <p className="text-gray-600 leading-relaxed mb-4" data-id="element-703">{result}</p>
      <div className="pt-4 border-t border-gray-200" data-id="element-704">
        <p className="text-sm font-bold text-[#0066FF] uppercase tracking-wide mb-1" data-id="element-705">
          Result:
        </p>
        <p className="text-gray-800 font-medium" data-id="element-706">{outcome}</p>
      </div>
    </div>;
}